import src from "IMAGE";
export default { src, width: 147, height: 81, blurWidth: 0, blurHeight: 0};
